import type { TourStep } from './tours';

/**
 * جولةُ الصفحة الرئيسية للزائر (18 أكتوبر 2026 — مركز غايتنا: «تعليماتُ المساعد تُحذف، وعملُ جولةٍ في الصفحة الرئيسية»).
 * بدلَ زرّ «اسأل المساعد» في ترويسة الموقع العام: جولةٌ قصيرة على أبواب الصفحة نفسِها، تبدأ وحدها في أول زيارة
 * ويُعيدها زرُّ «جولة» متى شاء الزائر. الهدفُ `data-tour` على أقسام الصفحة — وما لا يظهر تُعرض خطوتُه في الوسط.
 */
export const LANDING_TOUR: TourStep[] = [
  { target: 'ld:hero', title: 'أهلاً بك في رفرفة', text: 'المنصّة العربيّة المتكاملة لتشغيل التعليم والتربية الخاصة والإرشاد — للمراكز والمدارس والأسر والمختصّين.' },
  { target: 'ld:doors', title: 'ابدأ من بابك', text: 'مؤسسة، أو وليّ أمر، أو مختصّ، أو أكاديمية — لكلٍّ بابُه وما يجده خلفه.' },
  { target: 'ld:about', title: 'لمن رفرفة؟', text: 'افتح بطاقة فئتك لترى ما تقدّمه لك المنصة بالتفصيل.' },
  { target: 'ld:nav', title: 'المؤسسات والاستشارات والأكاديمية', text: 'تصفّح المراكز والمدارس، واحجز استشارة، واطّلع على الدورات — كلُّها بلا دخول.' },
  { target: 'ld:signin', title: 'الدخول والتسجيل', text: 'من هنا تدخل حسابك أو تسجّل مؤسستك أو حسابك المهني.' },
  { target: 'ld:contact', title: 'تواصل معنا', text: 'سؤالٌ أو طلبُ عرض؟ اكتب لنا من هنا ونردّ عليك.' },
];

const SEEN_KEY = 'rafrafa.landingTour.seen';
const EVENT = 'rafrafa:landing-tour';

/** هل رأى الزائرُ الجولة؟ (راحةٌ لا حالةٌ يُعتمد عليها — التخزينُ قد يُمنع فتُعرض مرّةً أخرى لا غير) */
export function landingTourSeen(): boolean {
  try { return localStorage.getItem(SEEN_KEY) === '1'; } catch { return true; }
}
export function markLandingTourSeen(): void {
  try { localStorage.setItem(SEEN_KEY, '1'); } catch { /* تخزينٌ ممنوع — لا شيء يُفعل */ }
}
/** زرُّ «جولة» في الترويسة يطلبها، والصفحةُ الرئيسية تستمع */
export function requestLandingTour(): void { window.dispatchEvent(new Event(EVENT)); }
export function onLandingTourRequest(cb: () => void): () => void {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
}
